import React, { useMemo } from 'react';
import { Body1, H4 } from '@xo-union/tk-ui-typography';
import { DisplayButton } from '@xo-union/tk-ui-links';
import Spinner from '@xo-union/tk-component-spinner';

import CardContainer from '../CardContainer';
import Card from '../Card';
import styles from './styles.scss';

interface Props {
  bulletPoints: string[];
  titleText: string;
  primaryLinkText: string;
  primaryOnClick: () => void;
  secondaryLinkText?: string;
  secondaryOnClick?: () => void;
  description?: string;
  type: 'rsvp' | 'registry' | 'dresscode';
  primaryButtonContent?: React.ReactNode;
  isLoading?: boolean;
  children?: React.ReactNode;
}

const BaseGuidanceCard: React.FC<Props> = ({
  bulletPoints,
  titleText,
  primaryLinkText,
  primaryOnClick,
  secondaryLinkText,
  secondaryOnClick,
  type,
  description,
  primaryButtonContent,
  isLoading = false,
  children,
}) => {
  const bulletPointsItems = useMemo(() => {
    return bulletPoints.map((bp, idx) => {
      return (
        <div key={`${idx}`} className={styles.numberContainer}>
          <span className={styles.numberIcon}>{idx + 1}</span>
          <span>{bp}</span>
        </div>
      );
    });
  }, [bulletPoints]);

  return (
    <CardContainer>
      <Card>
        <div className={`${styles.cardSection} ${styles.sectionFlex} ${styles[type]}`}>
          <div className={styles.textGroup}>
            <H4 className={styles.discoverText} as="h2">
              {titleText}
            </H4>
            {description && <Body1 className={styles.blankWorkflowBody}>{description}</Body1>}
            {bulletPoints.length > 0 && <Body1 className={styles.blankWorkflowBody}>{bulletPointsItems}</Body1>}
            <div className={styles.linkContainer}>
              {isLoading ? (
                <Spinner size="sm" />
              ) : (
                <>
                  <DisplayButton onClick={primaryOnClick} className={styles.pointer} color="primary">
                    {primaryButtonContent || primaryLinkText}
                  </DisplayButton>
                  {secondaryLinkText && secondaryOnClick && (
                    <>
                      <span className={styles.divider}>|</span>
                      <DisplayButton onClick={secondaryOnClick} className={styles.pointer} color={'primary'}>
                        {secondaryLinkText}
                      </DisplayButton>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </Card>
      {children}
    </CardContainer>
  );
};

export default BaseGuidanceCard;
